<template>
  <!-- <v-toolbar color="background"> -->
  <v-card flat :style="stickyStyle" @scroll="updateCurrentElevation()">
    <v-card-subtitle class="py-0 text-overline">
      {{ instructions }}
    </v-card-subtitle>

    <v-card-subtitle v-if="hasSlot('subtitle')" class="pb-0 mb-n4">
      <router-link
        v-if="subtitleLink"
        :to="subtitleLink"
        class="text-subtitle-1"
        style="text-decoration: none !important;"
      >
        <slot name="subtitle"></slot>
      </router-link>
      <span v-else>
        <slot name="subtitle"></slot>
      </span>
    </v-card-subtitle>

    <v-card-title>
      <!-- <v-row no-gutters>
          <v-col cols="12" xs="12" sm="8"> -->
      <slot name="title"></slot>
      <!-- </v-col> -->

      <!-- <v-spacer></v-spacer> -->

      <!-- <slot name="avatars"></slot> -->

      <!-- <v-col cols="12" xs="12" sm="4"> -->
      <slot name="actions"></slot>
      <!-- </v-col>
        </v-row> -->
    </v-card-title>
    <!-- <v-divider v-if="instructions && currentElevation" /> -->
    <v-divider />
    <!-- <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear> -->
  </v-card>
  <!-- </v-toolbar> -->
</template>

<script>
export default {
  components: {},

  props: {
    instructions: {
      type: String,
      required: false,
      default: null,
    },
    subtitleLink: {
      type: String,
      required: false,
      default: null,
    },
    sticky: {
      type: Number,
      required: false,
      default: -1,
    },
    stickyElevation: {
      type: Number,
      required: false,
      default: 10,
    },
    /* loadingData: {
      type: Boolean,
      required: false,
      default: false,
    }, */
  },

  data: () => ({
    //
    currentElevation: 0,
  }),

  computed: {
    //
    stickyStyle: function() {
      if (this.sticky > 0) {
        return 'position:sticky; top: ' + this.sticky + 'px; z-index: 1'
      } else {
        return ''
      }
    },
  },

  created: function() {
    window.addEventListener('scroll', this.updateCurrentElevation)
  },

  destroyed: function() {
    window.removeEventListener('scroll', this.updateCurrentElevation)
  },

  methods: {
    //
    hasSlot(name = 'default') {
      return !!this.$slots[name] || !!this.$scopedSlots[name]
    },
    updateCurrentElevation: function() {
      let threshold = this.instructions ? 50 : 5
      if (this.sticky > 0) {
        this.currentElevation = window.scrollY > threshold ? this.stickyElevation : 0
      } else {
        this.currentElevation = 0
      }
    },
  },
}
</script>

<style scoped></style>
